import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReferenceStock } from '@1po/1po-bff-fe-spec/generated/catalog/trading_data/model/ReferenceStock';
import { useTheme } from 'styled-components';
import { GlobeIcon, TruckIcon } from 'assets/icons';
import { getBulkOilDeliveryTime } from 'components/StockInfo/deliveryTimeUtils';
import { useIsOilChunkUserR1 } from 'domains/appContext/AppContext.requests';
import { Flex, Icon, Text } from 'UI';
import { getData, NO_DATA } from 'utils';

export function isDelayedStock(stock: NO_DATA | ReferenceStock): boolean {
  const stockData = getData(stock);
  const stockDelayed = stockData?.warehouses.find((s) => s.type === 'DELAYED');
  return stockData?.warehouses.length === 1 && stockDelayed !== undefined;
}

export interface DelayedStockProps {
  isCanOil?: boolean;
  isDrumOil?: boolean;
  isBulkOil?: boolean;
  relativeDate?: Date;
  isCertasOilFamily?: boolean;
}

export function DelayedStock({ isCanOil, isDrumOil, isBulkOil, relativeDate }: Readonly<DelayedStockProps>) {
  const theme = useTheme();
  const { t } = useTranslation();
  const isOilUserR1 = useIsOilChunkUserR1();

  const getStockText = () => {
    if (relativeDate && isBulkOil) {
      return (
        <Text type="base" bold color="grey35" displayStyle="stocks_purple">
          {getBulkOilDeliveryTime(t, relativeDate)}
        </Text>
      );
    } else if (isDrumOil || (isCanOil && isOilUserR1)) {
      return (
        <Text type="base" bold color="grey35" displayStyle="stocks_purple">
          {t(
            'catalog.reference.stock.out_of_stock.part_unavailable_within_six_business_days',
            'Within 6 business days',
          )}
        </Text>
      );
    } else {
      return (
        <Text type="base" bold color="grey35" displayStyle="warning">
          {t('common.restocking', 'Restocking')}
        </Text>
      );
    }
  };

  return (
    <Flex data-cy={'order-stock'}>
      <Icon
        IconComponent={isDrumOil || isBulkOil || (isCanOil && isOilUserR1) ? GlobeIcon : TruckIcon}
        size={20}
        mt={4}
        mr={5}
        display={'block'}
        color={isDrumOil || isBulkOil || (isCanOil && isOilUserR1) ? theme.color.palette_purple_7 : theme.color.warning}
        noPointer
      />
      {getStockText()}
    </Flex>
  );
}
